import templateUrl from './shippingNotice.view.html'

/**
 * Shipment (Shipping Notice) View route
 *
 * @namespace routes.ReportStockView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.shippingNotices.view',
  label: 'REPORT.SHIPPINGNOTICE.VIEW.TITLE',
  component: 'tmrReportShippingNoticeView',
  abstract: false,
  accessControl: 'TmrShippingOperationsAccessControl',
  data: {
    capabilities: ['Resource.view', 'Resource.ShippingNotice.view'],
  },
  url: '/shipments/notices/:id?shippingParcel',
  params: {
    shippingParcel: null,
  },
  resolve: {
    shippingParcels: /*@ngInject*/ (
      ShippingParcel,
      resource,
      tmrLimitZeroWorkaround
    ) =>
      ShippingParcel.query({
        limit: tmrLimitZeroWorkaround,
        'shippingNotice.id': resource.id,
      }).$promise,
    shippingParcel: /*@ngInject*/ ($transition$, shippingParcels) => {
      let id = $transition$.params().shippingParcel
      if (id)
        return shippingParcels.$promise.then(() => {
          let shippingParcel = shippingParcels.find(
            shippingParcel => shippingParcel.id == id
          )
          if (shippingParcel) return shippingParcel.$get()
        })
    },
    drilldown: /*@ngInject*/ (resource, shippingParcel) => {
      let drilldown = [{ label: resource.$getLabel() }]
      if (shippingParcel && shippingParcel.id)
        drilldown.push({
          param: 'shippingParcel',
          label: shippingParcel.$getLabel(),
        })
      return drilldown
    },
  },
}

/**
 * Component for {@link routes.tmrReportStockView Stock Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportShippingNoticeView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportShippingNoticeViewController',
  bindings: {
    resource: '<',
    shippingParcels: '<',
    shippingParcel: '<?',
    drilldown: '<?',
    currentPage: '<',
    pageSize: '<',
  },
}

/**
 * Controller of component {@link tmrReportShippingNoticeView}.
 *
 * @type {ngController}
 */
export class tmrReportShippingNoticeViewController {
  static ngType = 'controller'

  constructor(tmrShippingNoticeStates, tmrShippingParcelStates) {
    'ngInject'
    Object.assign(this, {
      shippingNoticeStates: tmrShippingNoticeStates,
      shippingParcelStates: tmrShippingParcelStates,
    })
  }

  $onInit() {
    this.expected = 0
    this.expected_detected = 0
    this.unexpected = 0
    this.detected = 0

    this.shippingParcels.forEach(shippingParcel => {
      const { expected, unexpected, detected } = shippingParcel.$counters()
      this.expected += expected
      this.expected_detected +=
        detected - unexpected > 0 ? detected - unexpected : 0
      this.unexpected += unexpected
      this.detected += detected
    })
  }
}
